// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e02c755d","455":"00b90356"}[chunkId] + ".chunk.js";
};